const getYear = () => {
  const year = window?.location?.pathname?.split("/")[1] || 2024;
  return year;
};

export default getYear;
